import { CustomerNotesQuery } from '@anyx/common-graphql';

import { useFormatUnixTimeToRelativeDate } from '../../hooks';
import { resolveCustomerCreatedChannel } from '../../utils';
import { CustomerActivityTimeline } from '../customer-activity-timeline';

export type CustomerNoteItemData = NonNullable<CustomerNotesQuery['CustomerNotesV3']>[number];

export const CustomerNoteItem = ({ note }: { note: CustomerNoteItemData }) => {
  const time = useFormatUnixTimeToRelativeDate(note.createdAt);
  const channel = resolveCustomerCreatedChannel(note.channel);
  return (
    <CustomerActivityTimeline.Noted
      id={note.id}
      note={note.text}
      editor={note.user.name}
      channel={channel}
      time={time}
    />
  );
};
